import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from 'src/app/modules/components/login/login.component';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-default-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor( private dialog: MatDialog, public auth: AuthService, private router: Router) {}

  ngOnInit() {
  }

  
  openLogin() {
    let dialogRef = this.dialog.open(LoginComponent, {
      height: '500px',
      width: '600px',
    })
    this.router.events
    .subscribe(() => {
      dialogRef.close();
    })
  }

}
